export default __webpack_public_path__ + "static/media/manor1.38067603.svg";